import { render, staticRenderFns } from "./WeightDialog.vue?vue&type=template&id=520c3fcc&"
import script from "./WeightDialog.vue?vue&type=script&lang=js&"
export * from "./WeightDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports